import styled from '@emotion/styled'
import { useRouter } from 'next/router'

import CodeInstallation from 'components/CodeInstallation'
import InstallPrompt from 'components/InstallPrompt'
import Modal from 'components/Modal'
import SlideInWrapper from 'components/SlideInWrapper'
import ConfigurationStep from 'components/integrations/gtm/ConfigurationStep'
import SignInStep from 'components/integrations/gtm/SignInStep'
import { useInstallPrompt } from 'hooks/useInstallPrompt'
import useNestedRoute from 'hooks/useNestedRoute'
import { useOrganization } from 'hooks/useOrganization'
import useSectionOpenedTracking from 'hooks/useSectionOpenedTracking'
import useTemplateId from 'hooks/useTemplateId'
import { useUser } from 'hooks/useUser'

const StyledModal = styled(Modal)`
	padding: ${({ theme }) => theme.spaces.space7};
	background-color: ${({ theme }) => theme.colors.light.primaryBackgroundColor};
	border-radius: ${({ theme }) => theme.borderRadiuses.xxl};
	width: 448px;
	max-width: 100%;
	display: flex;
	align-items: center;
`

function CodeSnippet() {
	const router = useRouter()
	const { organizationId } = useUser()
	const { organization } = useOrganization()
	const {
		isVisible: isInstallPromptVisible,
		tutorial: installPromptTutorial,
		areInstallationsLoading,
	} = useInstallPrompt()
	const isPlatformPromptVisible = isInstallPromptVisible && !!installPromptTutorial
	const { withTemplateId } = useTemplateId()

	const NestedRouteComponent = useNestedRoute({
		'gtm/sign-in': SignInStep,
		'gtm/setup': ConfigurationStep,
	})

	const hideModal = () => {
		router.push(withTemplateId(`/configurator/code-snippet`), undefined, { shallow: true })
	}

	useSectionOpenedTracking()

	if (areInstallationsLoading) {
		return null
	}

	return (
		<SlideInWrapper axis="y">
			{NestedRouteComponent && (
				<StyledModal hideModal={hideModal} data-testid="nested-route-handled-modal">
					<NestedRouteComponent />
				</StyledModal>
			)}
			<InstallPrompt />
			<CodeInstallation
				organizationId={organizationId}
				organizationTracking={organization?.tracking}
				isPlatformPromptVisible={isPlatformPromptVisible}
			/>
		</SlideInWrapper>
	)
}

export default CodeSnippet
